// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"704":"dcb99241","721":"5c244fb1"}[chunkId] + ".chunk.js";
};